import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import { dateTimeToPlainFormat } from '@/utils'

export interface OrderMemo {
  orderId: number
  buyBranchCode: SystemCode
  callNo: string
  shelfType: SystemCode
  collectionType: SystemCode
  status: SystemCode
  handlingType: SystemCode
  appendixCode: SystemCode
  updatedTime: string
  updatedBranchCode: SystemCode
  workMemo: string
  workMemoTime: string
  workMemoBranchCode: SystemCode
  displayMemo: string
  displayMemoTime: string
  displayMemoBranchCode: SystemCode
  localMemo: string
  localMemoTime: string
  localMemoBranchCode: SystemCode
  revision: number
}

export const defaultOrderMemo = (): OrderMemo => ({
  orderId: 0,
  buyBranchCode: defaultSystemCode(),
  callNo: '',
  shelfType: defaultSystemCode(),
  collectionType: defaultSystemCode(),
  status: defaultSystemCode(),
  handlingType: defaultSystemCode(),
  appendixCode: defaultSystemCode(),
  updatedTime: '',
  updatedBranchCode: defaultSystemCode(),
  workMemo: '',
  workMemoTime: '',
  workMemoBranchCode: defaultSystemCode(),
  displayMemo: '',
  displayMemoTime: '',
  displayMemoBranchCode: defaultSystemCode(),
  localMemo: '',
  localMemoTime: '',
  localMemoBranchCode: defaultSystemCode(),
  revision: 0
})

export function OrderMemoFromJSON(json: any): OrderMemo {
  return {
    orderId: exists(json, 'order_id') ? json.order_id : 0,
    buyBranchCode: exists(json, 'buy_branch_code')
      ? SystemCodeFromJSON(json.buy_branch_code)
      : defaultSystemCode(),
    callNo: exists(json, 'call_no') ? json.call_no : '',
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    status: exists(json, 'status')
      ? SystemCodeFromJSON(json.status)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    updatedTime: exists(json, 'updated_time')
      ? dateTimeToPlainFormat(json.updated_time)
      : '',
    updatedBranchCode: exists(json, 'updated_branch_code')
      ? SystemCodeFromJSON(json.updated_branch_code)
      : defaultSystemCode(),
    workMemo: exists(json, 'work_memo') ? json.work_memo : '',
    workMemoTime: exists(json, 'work_memo_time')
      ? dateTimeToPlainFormat(json.work_memo_time)
      : '',
    workMemoBranchCode: exists(json, 'work_memo_branch_code')
      ? SystemCodeFromJSON(json.work_memo_branch_code)
      : defaultSystemCode(),
    displayMemo: exists(json, 'display_memo') ? json.display_memo : '',
    displayMemoTime: exists(json, 'display_memo_time')
      ? dateTimeToPlainFormat(json.display_memo_time)
      : '',
    displayMemoBranchCode: exists(json, 'display_memo_branch_code')
      ? SystemCodeFromJSON(json.display_memo_branch_code)
      : defaultSystemCode(),
    localMemo: exists(json, 'local_memo') ? json.local_memo : '',
    localMemoTime: exists(json, 'local_memo_time')
      ? dateTimeToPlainFormat(json.local_memo_time)
      : '',
    localMemoBranchCode: exists(json, 'local_memo_branch_code')
      ? SystemCodeFromJSON(json.local_memo_branch_code)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
